import { render, staticRenderFns } from "./PreviewDailyNewsCardsComponent.vue?vue&type=template&id=63691acd&"
import script from "./PreviewDailyNewsCardsComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewDailyNewsCardsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports